<template>
	<el-dialog
		class="chat-pinned-messages-dialog im-dialog-shell im-dialog-shell--md im-dialog-shell--mobile-center"
		title="置顶消息"
		:visible="visible"
		width="520px"
		append-to-body
		@update:visible="$emit('update:visible', $event)"
	>
		<div class="top-message-list" v-loading="loading">
			<empty-state
				v-if="!loading && topMessageList.length === 0"
				class="empty"
				icon="el-icon-top"
				title="暂无置顶消息"
				compact
			></empty-state>
			<div v-for="item in topMessageList" :key="item.id" class="top-message-item" @click="$emit('locate', item)">
				<div class="item-avatar">
					<head-image :name="showName(item)" :size="38" :url="headImage(item)" :id="item.sendId"></head-image>
				</div>
				<div class="item-body">
					<div class="item-header">
						<span class="name">{{ showName(item) }}</span>
						<span class="time">{{ $date.toTimeText(item.sendTime, true) }}</span>
					</div>
					<div class="item-content" v-html="renderTopMessageContent(item)"></div>
				</div>
				<button
					v-if="canManage"
					type="button"
					class="item-action item-action--remove"
					:title="removingId == item.id ? '取消中' : '取消置顶'"
					:disabled="removingId == item.id"
					@click.stop="$emit('remove', item)"
				>
					<i :class="removingId == item.id ? 'el-icon-loading' : 'el-icon-close'"></i>
				</button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
	name: "chatPinnedMessagesDialog",
	components: {
		HeadImage
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		topMessageList: {
			type: Array,
			default: () => []
		},
		canManage: {
			type: Boolean,
			default: false
		},
		removingId: {
			type: [Number, String],
			default: null
		},
		headImage: {
			type: Function,
			default: () => ""
		},
		showName: {
			type: Function,
			default: () => ""
		}
	},
	methods: {
		renderTopMessageContent(msgInfo) {
			if (!msgInfo) {
				return "";
			}
			if (msgInfo.type == this.$enums.MESSAGE_TYPE.TEXT) {
				return this.$emo.transform(this.$str.html2Escape(msgInfo.content), "emoji-normal");
			}
			return this.$msgUtil.previewContent(msgInfo);
		}
	}
}
</script>

<style scoped lang="scss">
.chat-pinned-messages-dialog {
	::v-deep .el-dialog {
		width: min(520px, calc(100vw - 24px)) !important;
		max-height: calc(100vh - 24px);
		display: flex;
		flex-direction: column;
	}

	::v-deep .el-dialog__body {
		flex: 1;
		min-height: 0;
		overflow: hidden;
		padding: 12px 18px 16px;
	}

	.top-message-list {
		max-height: min(430px, calc(100vh - 156px));
		overflow: auto;
		padding-right: 2px;
	}

	.empty {
		min-height: 148px;
	}

	.top-message-item {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px 11px;
		border-radius: 6px;
		border: 1px solid var(--im-control-border);
		background: var(--im-control-soft-bg);
		cursor: pointer;
		transition: background 0.2s ease, border-color 0.2s ease;

		&:not(:last-child) {
			margin-bottom: 10px;
		}

		&:hover {
			border-color: rgba(var(--im-primary-rgb), 0.2);
			background: rgba(var(--im-primary-rgb), 0.04);
		}
	}

	.item-avatar {
		flex-shrink: 0;
	}

	.item-body {
		min-width: 0;
		flex: 1;
		text-align: left;
	}

	.item-header {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.name {
		font-size: var(--im-font-size);
		font-weight: 600;
		color: var(--im-text-color);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.time {
		flex-shrink: 0;
		font-size: var(--im-font-size-smaller);
		color: var(--im-text-color-light);
	}

	.item-content {
		margin-top: 4px;
		font-size: var(--im-font-size-small);
		line-height: 1.5;
		color: var(--im-text-color-light);
		word-break: break-all;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.item-action {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		border-radius: 6px;
		background: rgba(var(--im-black-rgb), 0.04);
		color: var(--im-color-primary);
		font-size: 13px;
		border: none;
		cursor: pointer;
		transition: background 0.2s ease, color 0.2s ease;
	}

	.item-action--remove {
		color: var(--im-text-color-light);

		&:hover:not(:disabled) {
			background: rgba(var(--im-danger-rgb), 0.10);
			color: var(--im-color-danger);
		}

		&:disabled {
			cursor: wait;
			opacity: 0.8;
		}
	}
}

@media (max-width: 640px) {
	.chat-pinned-messages-dialog {
		::v-deep .el-dialog__body {
			padding: 10px 14px 14px;
		}

		.top-message-list {
			max-height: calc(100vh - 150px);
		}
	}
}
</style>
